import { useServiceResponse } from '../useServiceResponse';

export const useHasPromotionalCode = (): boolean => {
	const { retrievePromoCodeDetail } = useServiceResponse();

	return retrievePromoCodeDetail === undefined ? false : true;
};
